import { Button, IconArrowLeft, IconArrowRight } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface IActHeaderComponents extends IHeaderParams {
    label: string;
    collapseKeys?: string[];
    isUseNavigateBtn?: boolean;
    workOrderId?: number;
}

const containerStyle = { display: 'flex', alignItems: 'center', width: '100%' };
const buttonStyle = { padding: '0', fontWeight: '700', fontSize: '14px' };

export const CollapseKeysHeaderComponent: React.FC<IActHeaderComponents> = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { label, collapseKeys, api, isUseNavigateBtn = false, workOrderId } = props;

    const [isExpanded, setIsExpanded] = useState(true);

    const onExpandCollapseClick = useCallback(
        (e) => {
            e.stopPropagation();
            e.preventDefault();

            if (collapseKeys?.length) {
                api.setColumnsVisible(collapseKeys, !isExpanded);
                setIsExpanded(!isExpanded);
            }
        },
        [api, collapseKeys, isExpanded],
    );

    return (
        <div style={containerStyle}>
            {isUseNavigateBtn ? (
                <Button
                    label={label}
                    onClick={() => (workOrderId ? navigate(`/projects/uer/${id}/order/${workOrderId}`) : null)}
                    view="clear"
                    style={buttonStyle}
                />
            ) : (
                label
            )}
            {collapseKeys?.length && (
                <Button
                    view="clear"
                    iconRight={isExpanded ? IconArrowLeft : IconArrowRight}
                    onlyIcon
                    onClick={onExpandCollapseClick}
                    size="xs"
                    form="brick"
                />
            )}
        </div>
    );
};

CollapseKeysHeaderComponent.displayName = 'WorkOrderHeaderComponent';
